import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js'
import { memo } from 'react'
import { Bar } from 'react-chartjs-2'

import DataNotFound from './DataNotFound'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface HorizontalBarChartProps {
  labels: string[]
  datas: number[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callbackLabel: (tooltipItem: any) => string
}

const HorizontalBarChart = memo(({ labels, datas, callbackLabel }: HorizontalBarChartProps) => {
  if (datas.every((d) => d === 0)) {
    return <DataNotFound className='h-[33vh]' />
  }

  const data = {
    labels,
    datasets: [
      {
        data: datas,
        borderColor: '#00CC00',
        backgroundColor: '#00CC00',
      },
    ],
  }

  const options = {
    indexAxis: 'y' as const,
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: { label: callbackLabel },
        displayColors: false,
        position: 'average' as const,
      },
      legend: {
        display: false,
        position: 'right' as const,
      },
      title: {
        display: false,
        text: 'Chart.js Horizontal Bar Chart',
      },
    },
  }

  return <Bar className='max-h-[33vh]' options={options} data={data} />
})

export default HorizontalBarChart
